import { usePermissions } from './use-permissions';

export function usePermission(name) {
  const permissions = usePermissions();
  return permissions.includes(name);
}
